/**
 * Ankieta prezentowana na warstwie rezygnacji z subskrypcji za gwarancję lub usługę
 * Obsługuje zdarzenia związane z wyborem powodu rezygnacji i wysłaniem formularza
 */
app.service('subscriptionResignForm', function () {

	function init() {
		setEvents();
	}

	function setEvents() {

		$('body')
			.on('click', 'input[name=resignReason]', function () {
				let $modal = $(this).closest('#warranty-resign-modal, #service-resign-modal, #payment-method-resign-modal');
				let $resignMessage = $('.resign-message', $modal);
				let $resignTextarea = $resignMessage.find('textarea');
				let $confirmResignation = $('.confirm-resignation', $modal);

				const isOtherReason = $(this).val() === 'otherReason';
				$resignMessage.toggleClass('is-visible', isOtherReason);
				const isTextareaEmpty = $resignTextarea.val().trim().length === 0;
				$confirmResignation.toggleClass('is-disabled', isOtherReason && isTextareaEmpty);

				if (isOtherReason) {
					$resignTextarea.focus();
				} else {
					$resignTextarea.val('');
				}
			})
			.on('input', '.resign-message textarea', function () {
				let $modal = $(this).closest('#warranty-resign-modal, #service-resign-modal, #payment-method-resign-modal');
				let $confirmResignation = $('.confirm-resignation', $modal);

				const isTextareaEmpty = $(this).val().trim().length === 0;
				$confirmResignation.toggleClass('is-disabled', isTextareaEmpty);
			});
	}

	function getResignFormData() {
		let $resignForm = $('#warranty-resign-modal, #service-resign-modal, #payment-method-resign-modal');
		const closeReasonName = $resignForm.find('input[name=resignReason]:checked').parent().text().trim();
		const closeReasonDescription = $resignForm.find('textarea').val() || null;

		return {closeReasonName, closeReasonDescription};
	}

	return {
		init,
		getResignFormData
	};
});